import React from 'react'; //eslint-disable-line
import goTrackerConfig from 'goTrackerConfig';
import format from 'date-fns/format';
import moment from 'moment';
import packageJson from '../../package.json';
// import { toast } from 'react-toastify';
// import { Toast, ToastError, defaultToastStyle, errorToastStyle, ToastSuccess, successToastStyle } from './../components/toastNotification'; //eslint-disable-line

export default {
  toTitleCase(str, exceptions = []) {
    const tmpAr = str.split(' ');
    tmpAr.forEach((word, idx) => {
      if (!exceptions.includes(word)) {
        tmpAr[idx] = word.replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      }
    });
    return tmpAr.join(' ');
  },

  isUserAdmin() {
    return true;
  },

  hasAudience(key) {
    if (!goTrackerConfig.featureAudience || !goTrackerConfig.featureAudience.hasOwnProperty(key)) {
      return false;
    }
    const regularExpression = new RegExp(goTrackerConfig.featureAudience[key], 'i');
    return regularExpression.test(goTrackerConfig.audiences);
  },
  // showToastMessage(message) {
  //   return toast(<Toast message={message} />, defaultToastStyle);
  // },
  // showToastErrorMessage(arError, config) {
  //   toast(<ToastError error={arError} config={config} />, errorToastStyle);
  // },
  // showToastSuccessMessage(message) {
  //   toast(<ToastSuccess message={message} />, successToastStyle);
  // },
  // hideToast(toastId) {
  //   toast.dismiss(toastId);
  // },
  isEmptyString(str) {
    return str.toString().replace(/ /g, '') === '';
  },
  isNullOrEmpty(val) {
    return val === null || !val || val === '';
  },
  formatTripName(tripName, isTwentyFourHour = true) {
    if (this.isNullOrEmpty(tripName)) return;

    const stations = tripName.split('-');

    //Split stations by ':' to check time format is (HH:mm)
    const stationsSplitByTime = stations.map(station => station.trim().split(':'));

    //Filter out stations with incorrect time format, not (HH:mm)
    const formattedStations = stationsSplitByTime.map(station => station.slice(0, 2));

    // If it is 24 hour clock just join back each field
    if (isTwentyFourHour) {
      return formattedStations.map(station => station.join(':')).join(' - ');
    }

    const stationNames = formattedStations.map(station => station.join(':').split(' '));

    // Format the station times by clock preference
    stationNames.forEach(station => {
      const stationName = this.formatTime(station[station.length - 1], isTwentyFourHour);

      station[station.length - 1] = stationName;
    });

    return stationNames.map(station => station.join(' ')).join(' - ');
  },
  isDate(date) {
    return (Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date));
  },
  formatTime(date, isTwentyFourHour = true) {
    const timeSetting = isTwentyFourHour ? 'HH:mm' : 'h:mm a';
    let newDate = date;

    if (typeof newDate === 'string' && !newDate.includes('T')) {
      const [hour, minute] = newDate.split(':');

      newDate = new Date(null, null, null, hour, minute);
    } else {
      newDate = new Date(newDate);
    }

    return format(newDate, timeSetting);
  },
  getTodayWithNewTime(hour, minute = null, seconds = null, milliseconds = null) {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate(), hour, minute, seconds, milliseconds);
  },
  toDate(date) {
    let newDate = date;

    if (typeof newDate === 'string' && !newDate.includes('T')) {
      const [hour, minute, seconds, milliseconds] = newDate.split(':');
      newDate =  this.getTodayWithNewTime(hour, minute, seconds, milliseconds);
    }

    return newDate;
  },
  timeDiffInMins(time1, time2) {
    // const diffMs = (moment(this.toDate(time2)) - moment(this.toDate(time1)));
    // const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    const diffMins = moment(this.toDate(time2))
      .diff(
        moment(this.toDate(time1)),
        'minutes'
      );
    return diffMins >= 0 ? diffMins : 0;
  },
  mapStationNameToPINS(strPinsMapping) {
    if (this.isNullOrEmpty(strPinsMapping)) return [];

    const pinsMappingArray = strPinsMapping.split('|');

    return pinsMappingArray.map(pins => {
      const [stationCode, stationName] = pins.split(':');

      return { stationCode, stationName};
    });
  },
  formatTripInfo(info, isLanguageFrench = true) {
    if (this.isNullOrEmpty(info)) return '';

    const tripInfo = info.split(/-|\//).slice(0, 2).map(x => x.trim());

    if (tripInfo.length === 1) {
      return tripInfo[0];
    }

    return isLanguageFrench ? tripInfo[1] : tripInfo[0];
  },
  showApplicationVersion() {
    console.log('UI version: ' + packageJson.version);
  }
};
